import { ReactNode, useMemo } from 'react'
import { ThemeProvider } from 'styled-components'
import { useAppSelector } from 'app/hooks'
import { selectThemeContrast, selectThemeMode } from 'app/reducer/themeSlice'
import { AppTheme, getContrastColors, getThemepalette } from 'config/theme'

interface ReduxThemeProviderProps {
  children: ReactNode
  themeExtensions?: Record<string, unknown>
}

const ReduxThemeProvider = ({
  children,
  themeExtensions
}: ReduxThemeProviderProps) => {
  const themeMode = useAppSelector(selectThemeMode)
  const themeContrast = useAppSelector(selectThemeContrast)

  const contrastColors = useMemo(
    () => getContrastColors(themeContrast),
    [themeContrast]
  )

  const theme: AppTheme = useMemo(
    () => ({
      ...getThemepalette(themeMode),
      ...(themeExtensions || {}),
      mode: themeMode,
      contrast: {
        id: themeContrast,
        text: contrastColors.text,
        background: contrastColors.background
      }
    }),
    [themeMode, themeContrast, contrastColors, themeExtensions]
  )

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}

export default ReduxThemeProvider
